/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import ReactDOM from 'react-dom';
// redux
import { Provider } from 'react-redux';
// ---
import { shouldClearLocalStorageWithActivate } from '../../phase2/survey';
import resizing from '../../phase2/survey/context/resizing';
import survey from '../../phase2/survey/context/survey';
// import Main from '../../phase2/survey/Main';
import WatchResize from '../../phase2/survey/component/watch-resize/WatchResize';
// ---
// redux - store
import { store } from '../broadcast';
import WidgetEmbedded from './page/widget';
import MainConnector from './page/widget/sequence/MainConnector';

/**
 * Popup component {@link MainConnector} - 下記 component で wrap します
 * - Redux.Provider
 * - survey.Provider
 * - resizing.Provider
 * - WatchResize
 * @return {*} React.node
 * @constructor
 */
const Popup = () => (
  <Provider store={store}>
    <survey.Provider>
      <resizing.Provider>
        <WatchResize>
          {
            // embedded　mobile and desktop embedded Inquiry
          }
          <MainConnector />
        </WatchResize>
      </resizing.Provider>
    </survey.Provider>
  </Provider>
);

/**
 * Embedded component {@link WidgetEmbedded} - 下記 component で wrap します
 * - Redux.Provider
 * - survey.Provider
 * - resizing.Provider
 * - WatchResize
 * @return {*} React.node
 * @constructor
 */
const Embedded = () => (
  <Provider store={store}>
    <survey.Provider>
      <resizing.Provider>
        <WatchResize>
          {
            // embedded - Nps / Thanks
          }
          <WidgetEmbedded />
        </WatchResize>
      </resizing.Provider>
    </survey.Provider>
  </Provider>
);

/**
 * embedded type `Survey` を作成します
 * - {@link Popup} ReactDOM.render します
 * - {@link Embedded} ReactDOM.render します
 * @param {HTMLElement} popup Popup root element `#rexSurveyRoot`
 * @param {HTMLElement} embedded Embedded root element `#rexSurveyEmbedded`
 * @constructor
 */
const SurveyEmbedded = ({ popup, embedded }) => {
  if (!shouldClearLocalStorageWithActivate()) {
    return;
  }
  // console.log('SurveyEmbedded', popup, embedded);
  // popup
  ReactDOM.render(<Popup />, popup);
  // embedded
  ReactDOM.render(<Embedded />, embedded);
};

export default SurveyEmbedded;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/index.js